import styled from "styled-components";
import { colorsPalettes, mixins } from "@similarweb/styles";

export const CUSTOM_MODAL_STYLES = {
    content: {
        padding: 0,
        width: 550,
    },
};

export const StyledButtonsContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 16px;

    & > *:not(:last-child) {
        margin-right: 4px;
    }
`;

export const StyledMessageText = styled.p`
    margin: 0;
    ${mixins.setFontVariant("caption", colorsPalettes.carbon["400"])};
    font-size: 16px;

    .highlight {
        font-weight: 700;
    }
`;

export const StyledMessage = styled.div`
    border-radius: 4px;
    margin-top: 28px;
    padding: 8px 8px 8px 0;
`;

export const StyledModalTitle = styled.h4`
    ${mixins.setFontVariant("h5", colorsPalettes.carbon["500"])};
    margin: 20px 0 0;
`;

export const StyledModalInner = styled.div`
    padding-left: 24px;
    padding-right: 24px;
`;

export const StyledModalContent = styled.div`
    user-select: none;
`;
